import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FortNoxService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  // FortNoxAbsence
  postAbsence(data: any): Observable<any> {
    // /api/absence
    return this.http.post<any>('/api/absence', data);
  }

  bulkAbsence(data: any): Observable<any[]> {
    // /api/absence (PUT)
    return this.http.put<any[]>('/api/absence', data);
  }

  deleteAbsence(data: any): Observable<any> {
    // /api/absence (DELETE with body)
    return this.http.request('delete', '/api/absence', { body: data });
  }

  // FortNoxSalary
  addSalaryItem(data: any): Observable<any> {
    // /api/salaryitem (POST)
    return this.http.post<any>('/api/salaryitem', data);
  }

  bulkSalaryItems(data: any): Observable<any[]> {
    // /api/salaryitem (PUT)
    return this.http.put<any[]>('/api/salaryitem', data);
  }

  deleteSalaryItems(data: any): Observable<any[]> {
    // /api/salaryitem (DELETE with body)
    return this.http.request<any[]>('delete', '/api/salaryitem', { body: data });
  }

  // FortNoxExpense
  addExpenseItem(data: any): Observable<any> {
    // /api/expenseitem (POST)
    return this.http.post<any>('/api/expenseitem', data);
  }

  bulkExpenseItems(data: any): Observable<any[]> {
    // /api/expenseitem (PUT)
    return this.http.put<any[]>('/api/expenseitem', data);
  }

  deleteExpenseItem(data: any): Observable<any> {
    // /api/expenseitem (DELETE with body)
    return this.http.request('delete', '/api/expenseitem', { body: data });
  }
}
